import script from "./Appearance.vue?vue&type=script&lang=ts&setup=true"
export * from "./Appearance.vue?vue&type=script&lang=ts&setup=true"

import "./Appearance.vue?vue&type=style&index=0&id=334c06e4&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334c06e4"]])

export default __exports__